import { CoinspaidActionResult } from "@models/C_Transactions";
import { PaymentsCommonErrorCodes } from "@models/MasterData";
import { PaymentMethodConfig } from "@models/payments/PaymentMethodConfig";
import { ErrorService } from "@providers/ErrorService";
import { TrackingService } from "@providers/TrackingService";
import { UserService } from "@providers/UserService";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
/* eslint-disable */
import {
  IQRPaymentMethodBehaviour,
  PaymentMethodBehaviour,
  QRPaymentMethodBehaviourResult,
  SkipAmountResult,
} from "./PaymentMethodBase";

export class CoinspaidMethodBehaviourResult extends QRPaymentMethodBehaviourResult {
  transactionId: string;
  amount: number;
  address: string;
  declare provider: "Coinspaid"; //important to distinct between qrpayments
}

export class CoinspaidDepositBehaviour extends PaymentMethodBehaviour implements IQRPaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.COINS_PAID.behaviour;
  name = this.behaviour.name; //"Coinspaid"
  image = this.behaviour.image; //"Coinspaid";
  track = this.behaviour.track; //"AccessToCoinspaid";
  isBank = this.behaviour.isBank; //false;
  minDepositAmount = 10;
  maxDepositAmount = 100000;
  amountButtons: number[] = [10, 20, 40, 50];
  amount = 20;

  constructor(userService: UserService, errorService: ErrorService, trackingService: TrackingService) {
    super(false, userService, errorService, trackingService);
  }

  skipAmountInput(): Observable<SkipAmountResult> {
    return new Observable<SkipAmountResult>();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  qr() {} //satisfy Interface

  paymentMetodExecution(): Observable<QRPaymentMethodBehaviourResult> {
    return this.userService.validateDepositCoinspaid("", this.amount).pipe(
      map((obj) => {
        return this.map(obj);
      }),
      catchError((error, caught) => {
        this.trackCatchError(this.behaviour.name, { err: error, caught: caught });
        return of(<QRPaymentMethodBehaviourResult>this.getGenericErrorResult());
      }),
    );
  }

  private map(input: CoinspaidActionResult): QRPaymentMethodBehaviourResult {
    const result = new CoinspaidMethodBehaviourResult();
    if (input.success) {
      result.success = true;
      result.transactionId = input.transactionId;
      result.amount = input.amount;
      result.address = input.address;
      result.payload = input.address;
      result.provider = "Coinspaid";
    } else {
      this.trackGenericError(this.behaviour.name, result);
      result.success = false;
      result.erroMessage = this.errorService.searchErrorCodeWithParams(
        "error" + input.errCode,
        input.errorParameters,
      );
      result.errorcode = input.errCode;
      result.sendToDocumentVerificationPage =
        input.errCode === PaymentsCommonErrorCodes.MUST_COMPLETE_DOC_VERIFICATION ||
        input.errCode === PaymentsCommonErrorCodes.LIMIT_NOT_VERIFIED_SURPASSED;
    }
    return result;
  }
}
